<metro-membership-breadcrumbs></metro-membership-breadcrumbs>

<div class="w-100 d-flex relative">
	<metro-membership-side-menu [sideMenuPositions]="sideMenuPositions" [isExpanded]="true"></metro-membership-side-menu>
	<div class="content-panel w-100">
		<router-outlet></router-outlet>
	</div>
</div>
